import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { areCurrentEnterprisePrivateMessageThreadsEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { canCurrentProfileReceiveCustomerMessages } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import ThreadsPanelComponent from '../components/ThreadsPanelComponent';
import { createThreadDraft, fetchThreads, selectThreadAndFetchData, switchViewMode } from '../actions/threads';
import {
    areThreadsLoading,
    canLoadMoreThreads,
    getCurrentThreadId,
    threadList,
    threadsFetchingOffset,
    getCurrentViewMode,
    getUnreadEnterpriseThreadsCount,
    getUnreadPrivateThreadsCount,
} from '../selectors/threads';

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        threads: threadList,
        currentThreadId: getCurrentThreadId,
        sendScroll: canLoadMoreThreads,
        offset: threadsFetchingOffset,
        areThreadsLoading,
        viewMode: getCurrentViewMode,
        unreadEnterpriseThreadsCount: getUnreadEnterpriseThreadsCount,
        unreadPrivateThreadsCount: getUnreadPrivateThreadsCount,
        canReceiveCustomerMessages: canCurrentProfileReceiveCustomerMessages,
        arePrivateMessageThreadsEnabled: areCurrentEnterprisePrivateMessageThreadsEnabled,
    }),

    (dispatch) => ({
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
        onThreadSelected: ({ threadId }: $TSFixMe) => dispatch(selectThreadAndFetchData({ threadId })),
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
        fetchThreads: ({ threadType, startIndex }: $TSFixMe) => dispatch(fetchThreads({ threadType, startIndex })),
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
        createThread: () => dispatch(createThreadDraft()),
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => Promise<any>' is not assignable to parameter of type 'Action<any>'.
        setThreadsViewMode: (mode: $TSFixMe) => dispatch(switchViewMode({ viewMode: mode })),
    })
)(ThreadsPanelComponent);
